__turbopack_context__.v({
  "actions": "YJa2Nq_actions",
  "arrow": "YJa2Nq_arrow",
  "audience": "YJa2Nq_audience",
  "audienceCopy": "YJa2Nq_audienceCopy",
  "audienceLoop": "YJa2Nq_audienceLoop",
  "closing": "YJa2Nq_closing",
  "eyebrow": "YJa2Nq_eyebrow",
  "hero": "YJa2Nq_hero",
  "heroOrbit": "YJa2Nq_heroOrbit",
  "heroSignal": "YJa2Nq_heroSignal",
  "heroSystem": "YJa2Nq_heroSystem",
  "heroTicket": "YJa2Nq_heroTicket",
  "lede": "YJa2Nq_lede",
  "orbit": "YJa2Nq_orbit",
  "page": "YJa2Nq_page",
  "primaryCta": "YJa2Nq_primaryCta",
  "promise": "YJa2Nq_promise",
  "secondaryCta": "YJa2Nq_secondaryCta",
  "signal": "YJa2Nq_signal",
  "ticket-drift": "YJa2Nq_ticket-drift",
});
